import React from "react";
import { Layout, Menu, Button, Drawer, Typography } from "antd";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import {
  ContactsIcon,
  DashboardIcon,
  LocationIcon,
  Logo,
  MyEventIcon,
  ProfileIcon,
  SettingsIcon,
  TemplateIcon,
  WalletIcon,
} from "../../../assets/CustomIcon";
import { Link, useLocation } from "react-router-dom";

const { Title } = Typography;
const { Sider } = Layout;

export default function Sidebar({
  collapsed = false,
  setCollapsed = () => {},
  isMobile = false,
  drawerOpen = false,
  setDrawerOpen = () => {},
  expandedWidth = 240,
  collapsedWidth = 64,
}) {
  // 👉 BEST WAY: Get current route
  const location = useLocation();
  const activeKey = location.pathname; // key will match route

  // 👉 Use pathname as menu key
  const menuItems = [
    {
      key: "/dashboard",
      icon: (
        <span className="iconBg">
          <DashboardIcon />
        </span>
      ),
      label: <Link to="/dashboard">Dashboard</Link>,
      className: "menuItem",
    },
    {
      key: "/my-profile",
      icon: (
        <span className="iconBg">
          <ProfileIcon />
        </span>
      ),
      label: <Link to="/my-profile">My Profile</Link>,
      className: "menuItem",
    },
    {
      key: "/events",
      icon: (
        <span className="iconBg">
          <MyEventIcon />
        </span>
      ),
      label: <Link to="/events">My Events</Link>,
      className: "menuItem",
    },
    {
      key: "/venues",
      icon: (
        <span className="iconBg">
          <LocationIcon />
        </span>
      ),
      label: <Link to="/venues">Venues</Link>,
      className: "menuItem",
    },
    {
      key: "/contacts",
      icon: (
        <span className="iconBg">
          <ContactsIcon />
        </span>
      ),
      label: <Link to="/contacts">My Contacts</Link>,
      className: "menuItem",
    },
    {
      key: "/templates",
      icon: (
        <span className="iconBg">
          <TemplateIcon />
        </span>
      ),
      label: <Link to="/templates">Templates</Link>,
      className: "menuItem",
    },
    {
      key: "/my-tickets",
      icon: (
        <span className="iconBg">
          <WalletIcon />
        </span>
      ),
      label: <Link to="/my-tickets">My Tickets</Link>,
      className: "menuItem",
    },
    {
      key: "/settings",
      icon: (
        <span className="iconBg">
          <SettingsIcon />
        </span>
      ),
      label: <Link to="/settings">Settings</Link>,
      className: "menuItem",
    },
  ];

  return (
    <>
      {/* Desktop Sider */}
      {!isMobile && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={expandedWidth}
          collapsedWidth={collapsedWidth}
          className="pageSider"
        >
          <div className="sidebarLogo">
            <Title
              level={1}
              style={{ margin: 0 }}
              className="sidebarLogoToggle"
            >
              <Link to="/" className="logoWrap">
                <Logo />
              </Link>
            </Title>

            <Button
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              size="small"
              className="toggleSidebarIcon"
            />
          </div>

          {/* 👉 Highlight active menu item */}
          <Menu mode="inline" items={menuItems} selectedKeys={[activeKey]} />
        </Sider>
      )}

      {/* Mobile Drawer */}
      {isMobile && (
        <Drawer
          title={
            <div className="sidebarLogo" style={{ padding: 0 }}>
              <Link to="/" className="logoWrap">
                <Logo />
              </Link>
            </div>
          }
          placement="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          size={expandedWidth}
          styles={{ body: { padding: 0 } }}
          className="drawerSidebar"
        >
          <Menu
            mode="inline"
            items={menuItems}
            selectedKeys={[activeKey]}
            onClick={() => setDrawerOpen(false)} // close drawer on navigation
          />
        </Drawer>
      )}
    </>
  );
}
